/* tslint:disable */
export const BETTER_THAN_FD = require('./bucketData/bucket20.json');

export const BETTER_THAN_SAVINGS = require('./bucketData/bucket21.json');

export const GROW_RICH = require('./bucketData/bucket22.json');

export const RETIRE_EARLIER_THAN_YOUR_PEERS = require('./bucketData/bucket23.json');

export const PLAN_YOUR_CHILDS_FUTURE = require('./bucketData/bucket24.json');

export const BUY_LIFES_LITTLE_HAPPINESS = require('./bucketData/bucket25.json');

export const FOR_THE_YOUNG_INDIA = require('./bucketData/bucket26.json');

export const THE_ENTREPRENUER = require('./bucketData/bucket27.json');

export const FOR_THE_NEWLY_MARRIED = require('./bucketData/bucket28.json');



// WEBPACK FOOTER //
// ./constants/fundBuckets/funds.ts